import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import PageShell from '../components/ui/PageShell'
import Card from '../components/ui/Card'
import SectionTitle from '../components/ui/SectionTitle'

const linkClass = 'text-[#00d4aa] hover:underline'

export default function Nutzungsbedingungen() {
  const location = useLocation()
  const isDashboard = location.pathname.startsWith('/dashboard')
  return (
    <PageShell>
      <div className="max-w-3xl space-y-6">
        <SectionTitle title="Nutzungsbedingungen" />
        <Card className="p-6 space-y-6 text-sm text-white/90">
          <p className="text-white/70">
            Diese Nutzungsbedingungen regeln die Nutzung des Dienstes „AI Mastering Studio“
            (mastering.anwendungen.online). Anbieter: Marc Fischer Digital Solution NRW, Inhaber Marc Fischer, Lärchenweg 9,
            50389 Wesseling. Ergänzend gelten die{' '}
            <Link to={isDashboard ? '/dashboard/agb' : '/agb'} className={linkClass}>
              AGB
            </Link>{' '}
            und die{' '}
            <Link to={isDashboard ? '/dashboard/datenschutz' : '/datenschutz'} className={linkClass}>
              Datenschutzerklärung
            </Link>
            .
          </p>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">1. Geltung und Annahme</h2>
            <p>
              Mit Registrierung oder Nutzung des Dienstes akzeptieren Sie diese Nutzungsbedingungen. Wenn Sie nicht
              einverstanden sind, dürfen Sie den Dienst nicht nutzen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">2. Konto und Zugang</h2>
            <p>
              Sie sind für die Geheimhaltung Ihrer Zugangsdaten und für alle Aktivitäten unter Ihrem Konto verantwortlich.
              Melden Sie vermuteten Missbrauch unverzüglich an{' '}
              <a href="mailto:kontakt@anwendungen.online" className={linkClass}>
                kontakt@anwendungen.online
              </a>
              . Konten können bei Verdacht auf Missbrauch oder Verstößen gesperrt werden.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">3. Zulässige Nutzung</h2>
            <p>Sie dürfen den Dienst nur für rechtmäßige Zwecke nutzen. Unzulässig sind insbesondere:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Upload von Inhalten, an denen Sie keine ausreichenden Rechte besitzen,</li>
              <li>rechtswidrige, beleidigende, diskriminierende oder jugendgefährdende Inhalte,</li>
              <li>Manipulation, Überlastung oder Angriffe auf Systeme, APIs oder andere Nutzer,</li>
              <li>Umgehung von Credits-, Sicherheits- oder Zugriffsbeschränkungen,</li>
              <li>automatisiertes Scraping oder Reverse Engineering, soweit gesetzlich nicht erlaubt.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">4. Inhalte und Rechte am Audio</h2>
            <p>
              Sie behalten alle Rechte an Ihren hochgeladenen Audiodateien. Mit dem Upload räumen Sie dem Anbieter ein
              einfaches, auf die Vertragserfüllung beschränktes Recht ein, die Dateien zu speichern, zu verarbeiten und
              Ergebnisdateien für Sie bereitzustellen. Sie versichern, dass Ihre Uploads keine Rechte Dritter verletzen und
              stellen den Anbieter von Ansprüchen Dritter frei, soweit Sie den Verstoß zu vertreten haben.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">5. Credits und Fair Use</h2>
            <p>
              Credits sind an Ihr Konto gebunden. Missbräuchliche Nutzung (z.&nbsp;B. systematische Missachtung von Limits,
              Weitergabe von Konten) kann zur Sperrung und zum Verfall nicht verbrauchter Credits führen. Startguthaben und
              Aktionen können jederzeit geändert werden.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">6. Verfügbarkeit und Änderungen</h2>
            <p>
              Funktionen können weiterentwickelt, eingeschränkt oder eingestellt werden. Wesentliche Änderungen der
              Nutzungsbedingungen werden im Dienst oder per E-Mail bekanntgegeben. Fortgesetzte Nutzung nach Inkrafttreten gilt
              als Zustimmung, soweit gesetzlich zulässig.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">7. Haftungshinweis zur Verarbeitung</h2>
            <p>
              Mastering-Ergebnisse sind technische Verarbeitungshilfen. Prüfen Sie Ergebnisse vor Veröffentlichung. Der
              Anbieter übernimmt keine Garantie für subjektive Klangqualität oder kommerziellen Erfolg.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">8. Kontakt</h2>
            <p>
              Marc Fischer Digital Solution NRW · Lärchenweg 9 · 50389 Wesseling
              <br />
              E-Mail:{' '}
              <a href="mailto:kontakt@anwendungen.online" className={linkClass}>
                kontakt@anwendungen.online
              </a>
              <br />
              Telefon:{' '}
              <a href="tel:+4922325509977" className={linkClass}>
                02232 / 5509977
              </a>
            </p>
            <p className="mt-2 text-white/50 text-xs">Stand: August 2026</p>
          </section>
        </Card>
        <p className="text-center">
          <Link to={isDashboard ? '/dashboard' : '/'} className={linkClass}>
            ← {isDashboard ? 'Zum Dashboard' : 'Zur Startseite'}
          </Link>
        </p>
      </div>
    </PageShell>
  )
}
